import { photoPosition, photoSide } from '@/types/uiPhoto.types'

export default function () {
  const { t } = useI18n()
  
  const uiPhotoData = () => {
    return {
      desktopPhotoPosition: photoPosition.RIGHT,
      photoDesktop: [{
        url: '/images/wellbeing-sale/dashboard/frame.png',
        public_id: '',
      }],
      photoMobile: [{
        url: '/images/wellbeing-sale/dashboard/frame.png',
        public_id: '',
      }],
      photoSide: photoSide.RIGHT,
      descriptionSize: 'big',
      description: {
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                value: t('wellbeingSale.dashboardHR.listTitle'),
              },
            ],
          },
          {
            nodeType: 'unordered-list',
            content: [
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.dashboardHR.bullet1'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.dashboardHR.bullet2'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.dashboardHR.bullet3'),
                      },
                    ],
                  },
                ],
              },
              {
                content: [
                  {
                    content: [
                      {
                        value: t('wellbeingSale.dashboardHR.bullet4'),
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                value: t('wellbeingSale.dashboardHR.paragraph2'),
              },
            ],
          },
          {
            nodeType: 'custom-button',
          },
        ],
      },
    }
  }

  return {
    uiPhotoData,
  }
}
